import { Controller } from "stimulus"
export default class extends Controller {
  static get targets() {
    return ['contentModal'];
  }
 
  connect(){
  }
  
  initialize(){

  }

 submit(e){
   if (e.target.checked  == true){
     e.target.checked = true; 
     Turbolinks.visit(this.data.get('checked-url')); 
   }

   else{
     e.target.checked =false ; 
     Turbolinks.visit(this.data.get('unchecked-url')); 
   }
 }

}



// WEBPACK FOOTER //
// ./app/javascript/store_front/controllers/submit_on_checked_controller.js